import { Component } from "react"
import Helmet from "react-helmet"
import navigationService from "src/navigation/NavigationService"
import "src/css/Error.css"

/**
 * Dedicated page when a valuation cannot be computed (e.g. no nearby sold homes).
 * Shown instead of the generic error popup for a friendlier experience.
 */
export default class NoValuationPage extends Component {
    render() {
        return (
            <div className="info-page-container">
                <Helmet>
                    <title>Valuation unavailable – HomeIndex</title>
                    <meta name="robots" content="noindex" />
                </Helmet>
                <div className="info-content-container" style={{ maxWidth: 520, margin: "0 auto", padding: "48px 24px", textAlign: "center" }}>
                    <div className="empty-icon" style={{ fontSize: 48, marginBottom: 16 }}>🏠</div>
                    <h1 className="info-title" style={{ marginBottom: 12 }}>Valuation unavailable</h1>
                    <p className="info-subtitle" style={{ marginBottom: 24 }}>
                        We couldn't compute a valuation for this address because there aren't enough nearby sold homes in our data yet.
                    </p>
                    <p style={{ color: "#6b7280", fontSize: "0.95rem", marginBottom: 32 }}>
                        Try another address or check back later as we add more sales data.
                    </p>
                    <button
                        type="button"
                        className="start-valuing-button"
                        style={{ padding: "12px 24px", fontSize: 16, cursor: "pointer", border: "none", borderRadius: 8, background: "#0f172a", color: "#fff", fontWeight: 600 }}
                        onClick={() => navigationService.navigateToHome()}
                    >
                        Search another address
                    </button>
                </div>
            </div>
        )
    }
}
